import type { ReactNode } from 'react';

export const symbol_borg: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M479.5-80q-7.5 0-15.09-2.18Q456.83-84.36 450-88L150-260q-15-8-22.5-21.8-7.5-13.79-7.5-30.2v-336q0-16.41 7.5-30.2Q135-692 150-700l300-172q6.75-3.64 14.25-5.82T480-880q7 0 14.93 2.18T510-872l300 172q14.25 8.17 22.13 21.91Q840-664.34 840-648v336q0 16.34-7.87 30.09Q824.25-268.17 810-260L510-88q-7.14 3.64-15.07 5.82Q487-80 479.5-80ZM180-450v138l270 155v-170h-94q-12.75 0-21.37-8.63Q326-344.25 326-357v-93H180Zm0-60h146v-93q0-12.75 8.63-21.38Q343.25-633 356-633h94v-170L180-648v138Zm206 123h187v-186H386v186Zm394-63H633v93q0 12.75-8.62 21.37Q615.75-327 603-327h-93v170l270-155v-138Zm0-60v-138L510-803v170h93q12.75 0 21.38 8.62Q633-615.75 633-603v93h147Z"
		/>
	</svg>
);
